// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__3Xdg2","title":"Home_title__3yA2a"};